/** @license ISC License (c) copyright 2017 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var curry = require('../core/curry')
var isPredOrFunc = require('../core/isPredOrFunc')
var predOrFunc = require('../core/predOrFunc')

// and : (a -> Boolean) | Pred -> (a -> Boolean) | Pred -> a -> Boolean
function and(f, g) {
  if(!(isPredOrFunc(f) && isPredOrFunc(g))) {
    throw new TypeError(
      'and: Preds or predicate functions required for first two arguments'
    )
  }

  return function (x) { return !!(predOrFunc(f, x) && predOrFunc(g, x)); }
}

module.exports = curry(and)
